import * as React from "react";
import { ChangeEvent } from "react";

import ReadOnlyField from "components/FormElements/ReadOnlyField";
import SelectField from "components/FormElements/SelectField";
import ToolTip from "components/ToolTip";
import { PAYMENT_SCHEDULES } from "utils";

import { ClientErrorsType } from "./types";
import { wageSchedules } from "./utils";

const SCHEDULE_OPTIONS = Object.keys(wageSchedules).map(value => ({
  label: wageSchedules[value].label,
  value,
}));

interface PropsType {
  errors: ClientErrorsType;
  onScheduleChange(e: ChangeEvent<HTMLInputElement>): void;
  readOnly: boolean;
  value: string;
}

export default function ScheduleTypeField(props: PropsType): JSX.Element {
  const { errors, onScheduleChange, readOnly, value } = props;

  const label = "Paycheck Schedule";
  const name = "wage_schedule[schedule_type]";

  if (readOnly) {
    return (
      <ReadOnlyField
        value={PAYMENT_SCHEDULES[value].label}
        {...{ label, name }}
      />
    );
  }

  return (
    <SelectField
      error={errors.schedule}
      onChange={onScheduleChange}
      options={SCHEDULE_OPTIONS}
      toolTip={
        <ToolTip
          heading="Paycheck Schedule"
          content={`Please select the schedule with which you
                    run your payroll. This calculates the amount to be
                    processed during each pay-period. Please see the
                    each schedule's description the adjacent simulator.`}
        />
      }
      {...{ label, name, value }}
    />
  );
}
